import { CategoryProp } from '../components/categoryTetris/categoryCard'
import { useAppSelector } from '../store'
import { categoriesImagesMap, random } from '../utils'

export const useGetTetrisCategoryData = (): CategoryProp[] => {
  const { categories } = useAppSelector((state) => state.categoryReducer)
  const cats = categories.map((cat) => ({
    title: cat.name,
    url: `/shop?category=${cat.name}&categoryId=${cat.siteCategoryId}`,
    image: {
      url: `/assets/categories/${categoriesImagesMap[cat.siteCategoryId] || `default_category_desktop${random(2) ? '_2' : ''}`}.jpg`,
      alt: cat.name,
    },
    productCategory: cat.siteCategoryId,
  }))
  if (cats.length < 5) {
    const totalToFill = 5 - cats.length
    const promoCats = ['top deals', 'most popular', 'trending', 'featured']
    for (let i = 0; i < totalToFill; i++) {
      cats.push({
        title: promoCats[i],
        url: `/shop?category=${promoCats[i]}`,
        image: {
          url: `/assets/categories/default_category_desktop_${random(5, 1)}.jpg`,
          alt: promoCats[i],
        },
      } as CategoryProp)
    }
  }
  return cats
}
